import { Capacitor } from "@capacitor/core";
import { Clipboard } from "@capacitor/clipboard";

export const isNative = Capacitor.isNativePlatform();
export const isMobileTestBuild = process.env.REACT_APP_MOBILE_TEST_BUILD === "true";
const SERVER_KEY = "procrypto.test-server";

export function validateBackendUrl(value, allowHttp = false) {
  const url = new URL(value.trim());
  if (url.username || url.password || url.search || url.hash || (url.pathname !== "/" && url.pathname !== "")) {
    throw new Error("Enter the backend origin only, without /api, credentials, or query parameters.");
  }
  if (url.protocol !== "https:" && !(allowHttp && url.protocol === "http:")) {
    throw new Error("Use an HTTPS backend URL.");
  }
  if (["localhost", "127.0.0.1", "[::1]", "0.0.0.0"].includes(url.hostname)) {
    throw new Error("Use your PC’s Wi-Fi IP address or an HTTPS tunnel. Localhost points to this phone.");
  }
  return url.origin;
}

export function backendUrl() {
  if (isNative && isMobileTestBuild) return localStorage.getItem(SERVER_KEY) || "";
  return (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
}

export function setTestBackend(value) {
  if (!isNative || !isMobileTestBuild) throw new Error("Server changes are available only in test builds.");
  const url = validateBackendUrl(value, Capacitor.getPlatform() === "android");
  localStorage.setItem(SERVER_KEY, url);
  window.location.replace("/");
}

export function resetTestBackend() {
  localStorage.removeItem(SERVER_KEY);
  window.location.replace("/");
}

export async function copyText(text) {
  if (isNative) await Clipboard.write({ string: text });
  else await navigator.clipboard.writeText(text);
}
